'use strict';
var _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
};
var PZText = function PZText(props) {
    var pzCurrTabId = (props.pzTabType && props.pzTabType == "subTab" || props.optionBasedSubTab && props.optionBasedSubTab == 1) && props.pzSubTab && props.pzSubTab.is_sub_tab == 1 ? props.pzSubTab.promize_tab_id : props.pzTab.promize_tab_id;
    var pzText = props.pzTexts;
    var pzSetting = pzText.promize_attribute_text_value;
    pzText.default_text = '';
    pzText.min_char = 0;
    var pzTextRefId = 1;
    var pzDomainText = props.commonTextSetting;
    var textSetting = props.pzCustomizer.attributeDomainTexts;
    var fontFamilies = 'font_ids' in pzSetting ? pzSetting['font_ids'].split(',') : '';
    var fontSizes = 'font_size_ids' in pzSetting ? pzSetting['font_size_ids'].split(',') : '';
    var textAlign = 'font_align_ids' in pzSetting ? pzSetting['font_align_ids'].split(',') : '';
    var fontColors = 'font_color_ids' ? pzSetting['font_color_ids'].split(',') : '';
    var textStyles = 'font_shape_ids' in pzSetting ? pzSetting['font_shape_ids'].split(',') : '';
    //let textSetting = this.props.pzCustomizer.attributeDomainTexts;
    var textFound = false;
    var showTopFonts = props.showTopFonts,
        activeFontFamily = props.fontFamily,
        activeFontSize = props.fontSize,
        activeFontFormatters = props.fontStyle,
        activeShowFontStyleForMobile = props.showFontStyleForMobile;
    var activeFontColor = textSetting['fontColor'][pzSetting.default_color].font_color_code; //props.settings.background_color;
    var activeSliderValue = props.TextComponent.state.sliderValue;
    var activeFontDec = _extends({}, activeFontFormatters); //(activeFontFormatters) ? JSON.parse(activeFontFormatters) : {}
    var activeFontWeight = activeFontDec['fontWeight'];
    var activeFontStyle = activeFontDec['fontStyle'];
    var activeFontDecoration = activeFontDec['underline'];
    var textObj = {};
    //textObj.text = ""
    if (props.pzCopyObjectsKeys.length > 0) {
        props.pzCopyObjectsKeys.map(function(objKey, index) {
            if (objKey.includes('text_' + pzText.promize_tab_attribute_id)) {
                if (props.pzCanvasObject[objKey]) {
                    textObj = props.pzCanvasObject[objKey];
                    if (textObj) {
                        activeFontFamily = textObj.fontFamily ? textObj.fontFamily : activeFontFamily;
                        activeFontSize = textObj.activeFontSize ? textObj.activeFontSize : activeFontSize;
                        activeFontWeight = textObj.fontWeight ? textObj.fontWeight : 'normal';
                        activeFontStyle = textObj.fontStyle ? textObj.fontStyle : 'normal';
                        activeFontDecoration = textObj.underline;
                        activeFontColor = textObj.fill;
                    }
                }
            }
        });
    }
    //console.log("textObj ", activeFontFamily, activeFontColor, activeFontWeight, activeFontStyle, activeFontDecoration)
    var isDisplayColorCode = false;
    if (fontColors.length > 1 && props.pzActiveOptions && Object.keys(props.pzActiveOptions).length > 0) {
        // Object.keys(props.pzActiveOptions).map((objKey, index) => {
        for (var objKey in props.pzActiveOptions) {
            var currActionOptions = props.pzActiveOptions[objKey];
            var findIdx = currActionOptions.findIndex(function(element) {
                return typeof element === "string" && element.indexOf('silkscreen') !== -1;
            });
            var findIdxDyesub = currActionOptions.findIndex(function(element) {
                return typeof element === "string" && element.indexOf('dyesub') !== -1;
            });
            if (findIdx >= 0) {
                isDisplayColorCode = true;
                break;
            } else if (findIdxDyesub >= 0) {
                activeFontColor = props.pzDyesubTextDefaultColor;
                // console.log("activeFontColor ", activeFontColor)
                break;
            }
        }
    }
    if (!activeFontColor) {
        activeFontColor = textSetting['fontColor'][pzSetting.default_color].font_color_code;
    }
    //console.log(activeFontColor, "activeFontColor")
    var currAttributes = props.pzCustomizer.attributes[props.pzTab.promize_tab_id];
    var currTabAttributes = pzText.promize_tab_attribute_id in currAttributes ? currAttributes[pzText.promize_tab_attribute_id] : null;
    var currAttributeCode = currTabAttributes ? currTabAttributes.promize_attribute.attribute_code : null;
    var textObjText = textObj && 'text' in textObj ? textObj.text : '';
    return React.createElement(
        React.Fragment,
        null,
        React.createElement(
            'div', {
                className: 'pz-design-item-wrapper'
            },
            React.createElement(
                'div', {
                    className: 'pz-text-control-wrapper'
                },
                React.createElement(
                    'div', {
                        className: 'pz-text-item' + (isDisplayColorCode ? ' pz-color-option' : '') + ' '
                    },
                    React.createElement('input', {
                        type: 'text',
                        value: textObjText,
                        className: 'pz-text-logo-input-text',
                        id: 'pz-text-id-' + pzText.promize_tab_attribute_id,
                        name: 'pz-text-name-' + pzText.promize_tab_attribute_id,
                        minlength: pzText.min_char,
                        maxLength: pzText.max_char,
                        onChange: function onChange(e) {
                            e.preventDefault(), props.TextComponent.pzTextProperty(pzTextRefId, 'text', e.target.value, pzText);
                        },
                        onFocus: function onFocus(e) {
                            e.preventDefault(), props.TextComponent.pzTextSwitchModel(e, pzText);
                        }
                    }),
                    textStyles.length > 1 && React.createElement(
                        'div', {
                            className: 'pz-text-style'
                        },
                        React.createElement(
                            'div', {
                                className: 'pz-text-style-btns'
                            },
                            React.createElement(
                                'button', {
                                    className: 'pz-sm-text-style',
                                    onClick: function onClick(e) {
                                        e.preventDefault(), props.TextComponent.pzShowFontAlignForMobile(true);
                                    }
                                },
                                'Aa'
                            ),
                            React.createElement(
                                'div', {
                                    className: 'pz-text-align-btn-grp ' + (activeShowFontStyleForMobile ? 'active' : '')
                                },
                                textStyles.map(function(fontStyle) {
                                    var fontShapeName = pzDomainText['fontShapes'][fontStyle]['font_shape_name'].toLowerCase();
                                    var activeClass = '';
                                    if (fontShapeName == 'bold') {
                                        activeClass = activeFontWeight.toLowerCase() == 'bold' ? 'active' : '';
                                    }
                                    if (fontShapeName == 'italic') {
                                        activeClass = activeFontStyle.toLowerCase() == 'italic' ? 'active' : '';
                                    }
                                    if (fontShapeName == 'underline') {
                                        activeClass = activeFontDecoration ? 'active' : '';
                                    }
                                    return React.createElement(
                                        'button', {
                                            className: activeClass,
                                            onClick: function onClick(e) {
                                                e.preventDefault(), props.TextComponent.pzTextShapes(pzTextRefId, 'fontShape', pzDomainText['fontShapes'][fontStyle]['font_shape_name'].toLowerCase(), pzText);
                                            }
                                        },
                                        React.createElement('i', {
                                            className: "active fa fa-" + pzDomainText['fontShapes'][fontStyle]['font_shape_name'].toLowerCase()
                                        })
                                    );
                                })
                            )
                        )
                    ),
                    React.createElement(
                        'div', {
                            className: 'pz-text-color-wrapper'
                        },
                        React.createElement(
                            'button', {
                                className: 'pz-sm-clr-picker'
                            },
                            React.createElement('img', {
                                src: 'images/clr-picker.png',
                                alt: 'Clr-picker'
                            })
                        ),
                        React.createElement(
                            'div', {
                                className: 'pz-text-color-container'
                            },
                            isDisplayColorCode && fontColors.length > 1 && React.createElement(
                                'div', {
                                    className: 'pz-text-color-picker'
                                },
                                React.createElement(
                                    'label', {
                                        'for': 'pz-text-font'
                                    },
                                    'Text Color'
                                ),
                                React.createElement(
                                    'ul', {
                                        className: 'pz-font-color-list'
                                    },
                                    fontColors.map(function(fontCol) {
                                        /* return (<li className={props.textSetting['fill'] == pzDomainText['fontColor'][fontCol]['font_color_code'] ? 'active' : ''} onClick={(e) => { e.preventDefault(), props.TextComponent.pzTextProperty(pzTextRefId, 'fill', pzDomainText['fontColor'][fontCol]['font_color_code'], pzText) }}><div className="pz-text-color" style={{ backgroundColor: pzDomainText['fontColor'][fontCol]['font_color_code'] }}></div></li>) */
                                        return React.createElement(
                                            'li', {
                                                className: activeFontColor.toLowerCase() == pzDomainText['fontColor'][fontCol]['font_color_code'].toLowerCase() ? 'active' : '',
                                                onClick: function onClick(e) {
                                                    e.preventDefault(), props.changePickerColor(e, pzDomainText['fontColor'][fontCol]['font_color_code'], pzText);
                                                }
                                            },
                                            React.createElement('div', {
                                                onMouseOver: function onMouseOver(e) {
                                                    e.preventDefault();
                                                    props.HomeComponent.pzHoverHandler(pzDomainText['fontColor'][fontCol]['font_color_name'], e);
                                                },
                                                onMouseOut: function onMouseOut(e) {
                                                    props.HomeComponent.pzHoverHandler('', e);
                                                },
                                                className: 'pz-text-color',
                                                style: {
                                                    backgroundColor: pzDomainText['fontColor'][fontCol]['font_color_code']
                                                }
                                            })
                                        );
                                    })
                                )
                            ), !isDisplayColorCode && currAttributeCode != 'delivery_count' &&
                            /* {(setting && setting.promize_setting.reference_id == 4 && setting.promize_setting.reference_name == "Color palette") && */
                            React.createElement(
                                'div', {
                                    className: 'pz-text-color-picker',
                                    onMouseOver: function onMouseOver(e) {
                                        e.preventDefault();
                                        props.HomeComponent.pzHoverHandler('Pick Your Text Color', e);
                                    },
                                    onMouseOut: function onMouseOut(e) {
                                        props.HomeComponent.pzHoverHandler('', e);
                                    }
                                },
                                React.createElement(
                                    'div', {
                                        className: 'pz-clr-wrapper'
                                    },
                                    React.createElement(
                                        'div', {
                                            className: 'pz-clr-pciker'
                                        },
                                        React.createElement(JsColor, _extends({}, props, {
                                            className: 'pzcolorpicker',
                                            value: activeFontColor,
                                            id: 'pzcolorpicker',
                                            onChange: function onChange(e, selected) {
                                                props.changePickerColor(e, selected, pzText);
                                            }
                                        }))
                                    )
                                )
                            )
                        )
                    )
                ),
                React.createElement(
                    'div', {
                        className: 'pz-text-decoration-wrapper'
                    },
                    fontFamilies.length > 1 && React.createElement(
                        'div', {
                            className: 'pz-text-item-font'
                        },
                        React.createElement(
                            'label', {
                                'for': 'pz-text-font'
                            },
                            'Typography',
                            React.createElement(
                                'span', {
                                    'class': 'label-hiphen'
                                },
                                '-'
                            )
                        ),
                        React.createElement(
                            'button', {
                                'class': 'pz-font-family',
                                onClick: function onClick(e) {
                                    e.preventDefault(), props.TextComponent.pzShowTopFonts();
                                }
                            },
                            'Show ',
                            '' + (showTopFonts == 'all' ? 'Less' : 'More')
                        ),
                        React.createElement(
                            'ul', {
                                className: "pz-font-family-list"
                            },
                            fontFamilies.map(function(font, index) {
                                if (showTopFonts != 'all' && index <= showTopFonts - 1 || showTopFonts == 'all') {
                                    var activeClassH = pzDomainText['fontFamilies'][font]['font_name'] == activeFontFamily ? 'active' : '';
                                    return React.createElement(
                                        'li', {
                                            className: activeClassH,
                                            onClick: function onClick(e) {
                                                e.preventDefault(), props.TextComponent.pzTextPropertyFontFamily(pzTextRefId, 'fontFamily', pzDomainText['fontFamilies'][font]['font_name'], pzText, pzDomainText['fontFamilies'][font]['font_file']);
                                            }
                                        },
                                        React.createElement(
                                            'span', {
                                                className: 'active',
                                                style: {
                                                    fontFamily: pzDomainText['fontFamilies'][font]['font_name']
                                                }
                                            },
                                            pzDomainText['fontFamilies'][font]['font_name'],
                                            ' '
                                        )
                                    );
                                }
                            })
                        )
                    )
                ),
                fontSizes.length > 1 && React.createElement(
                    'div', {
                        className: 'pz-text-item-size'
                    },
                    React.createElement(
                        'label', {
                            'for': 'pz-text-font'
                        },
                        'Size'
                    ),
                    React.createElement(
                        'button', {
                            className: 'pz-font-size',
                            onClick: function onClick(e) {
                                e.preventDefault(), props.TextComponent.pzShowFontSize();
                            }
                        },
                        React.createElement(
                            'span',
                            null,
                            activeFontSize
                        ),
                        React.createElement('i', {
                            className: 'fa fa-caret-down'
                        })
                    ),
                    React.createElement(
                        'ul', {
                            className: props.showFontSize ? "pz-font-size-list active" : "pz-font-size-list"
                        },
                        fontSizes.map(function(fontSz) {
                            return React.createElement(
                                'li', {
                                    className: 'active',
                                    onClick: function onClick(e) {
                                        e.preventDefault(), props.TextComponent.pzTextPropertySize(pzTextRefId, 'fontSize', pzDomainText['fontSizes'][fontSz]['font_size'], pzText);
                                    }
                                },
                                React.createElement(
                                    'span', {
                                        className: 'active'
                                    },
                                    pzDomainText['fontSizes'][fontSz]['font_size']
                                )
                            );
                        })
                    )
                ),
                textAlign.length > 1 && React.createElement(
                    'div', {
                        className: 'pz-text-alignment'
                    },
                    React.createElement(
                        'label', {
                            'for': 'pz-text-font'
                        },
                        'Alignment'
                    ),
                    React.createElement(
                        'button', {
                            className: 'pz-sm-text-align'
                        },
                        React.createElement('i', {
                            className: 'fa fa-align-left'
                        })
                    ),
                    React.createElement(
                        'div', {
                            className: 'pz-text-align-btn-grp'
                        },
                        textAlign.map(function(fontAlign) {
                            return React.createElement(
                                'button', {
                                    className: props.textSetting['textAlign'] == pzDomainText['textAligns'][fontAlign]['text_align_name'].toLowerCase() ? 'active' : '',
                                    onClick: function onClick(e) {
                                        e.preventDefault(), props.TextComponent.pzTextProperty(pzTextRefId, 'textAlign', pzDomainText['textAligns'][fontAlign]['text_align_name'].toLowerCase(), pzText);
                                    }
                                },
                                React.createElement('i', {
                                    className: "fa fa-align-" + pzDomainText['textAligns'][fontAlign]['text_align_name'].toLowerCase()
                                })
                            );
                        })
                    )
                )
            )
        )
    );
};
